import {
  PageBlueprint,
  createFrontendPlugin,
  type FrontendFeature,
} from '@backstage/frontend-plugin-api';
import { Navigate } from 'react-router-dom';

// The "DevOps" sidebar entry points here. /devops itself has no content of
// its own — it redirects to the first tab. Each DevOps section (VPN, Argo CD,
// Argo Workflows, IaC, CI) renders the shared DevOpsTabBar at the top of its
// own page, so navigation between them is a normal route change and every
// existing deep-link keeps working.
const devopsLandingPage = PageBlueprint.make({
  params: {
    path: '/devops',
    loader: () => Promise.resolve(<Navigate to="/argo-workflows" replace />),
  },
});

export const devopsModule: FrontendFeature = createFrontendPlugin({
  pluginId: 'devops-hub',
  extensions: [devopsLandingPage],
});
